import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { forwardRef } from "react";
import { InputAdornment, useMediaQuery, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { StyledTextField } from "./StyledTextField";
import { Icon } from "@iconify/react";
const StyledSearchInput = forwardRef(({ autoFocus = false, fullWidth = false, bordered = true, value, onChange, onKeyDown, handleResetCallback, }, ref) => {
    const theme = useTheme();
    const { t } = useTranslation();
    const isBelow1200 = useMediaQuery(theme.breakpoints.down(1201));
    return (_jsx(StyledTextField, { ref: ref, variant: "outlined", placeholder: `${t("placeholder.searchAnything")}...`, size: "medium", autoFocus: autoFocus, value: value, onChange: onChange, onKeyDown: onKeyDown, sx: {
            width: fullWidth ? "100%" : 320,
            justifyContent: "center",
            "& input:-webkit-autofill": {
                WebkitBoxShadow: "0 0 0 100px transparent inset !important",
                WebkitTextFillColor: "inherit",
                backgroundColor: "transparent !important",
                transition: "background-color 5000s ease-in-out 0s",
            },
            "& .MuiInputBase-root": {
                background: theme.palette.background.paper,
                height: 48,
                "&::placeholder": {
                    color: (theme) => `${theme.palette.text.disabled} !important`,
                    ...theme.typography.body2,
                },
                "& .MuiOutlinedInput-notchedOutline": {
                    border: bordered ? "auto" : "none",
                },
            },
        }, slotProps: {
            input: {
                sx: {
                    ...theme.typography.body2,
                },
                startAdornment: (_jsx(InputAdornment, { position: "start", children: _jsx(Icon, { icon: "eva:search-fill", width: "24", height: "24", color: theme.palette.text.disabled }) })),
                endAdornment: !isBelow1200 && value && value.length > 0 ? (_jsx(InputAdornment, { position: "start", onClick: handleResetCallback, sx: { cursor: "pointer" }, children: _jsx(Icon, { icon: "eva:close-fill", width: "24", height: "24", color: theme.palette.text.disabled }) })) : (_jsx(_Fragment, {})),
            },
        } }));
});
export default StyledSearchInput;
